export function toastr_success(a) {
    var notyf = new Notyf({ position: {x:'center',y:'top'} });
    notyf.success(a);
}